import {$, config, Router} from './bootstrap';

import common from './routes/common';
import home from './routes/home';
import business from './routes/business';
import merchandise from './routes/merchandise';
import compare from './routes/compare';
import logistics from './routes/logistics';
import modernStorage from './routes/modernStorage';
import movingServices from './routes/movingServices';
import move1 from './routes/move1';
import move2 from './routes/move2';
import archiveSolutions from './routes/archiveSolutions';
import internationalMove from './routes/internationalMove';
import logisticsSolutions from './routes/logisticsSolutions';
import businessStorage from './routes/businessStorage';
import moveNational from './routes/moveNational';
import moveInternational from './routes/moveInternational';
import moveNationalBusiness from './routes/moveNationalBusiness';
import moveInternationalBusiness from './routes/moveInternationalBusiness';
import service from './routes/service';
import faq from './routes/faq';
import jobs from './routes/jobs';
import manage from './routes/manage';
import pickup from './routes/pickup';
import billing from './routes/billing';
import order from './routes/order';
import account from './routes/account';
import sponsorship from './routes/sponsorship';
import pricing from './routes/pricing';

const routes = new Router({
    common,
    tplPagesHome: home,
    tplPagesBusiness: business,
    tplPagesMerchandise: merchandise,
    tplPagesCompare: compare,
    tplPagesLogistics: logistics,
    tplPagesModernStorage: modernStorage,
    tplPagesMovingServices: movingServices,
    tplPagesMove1: move1,
    tplPagesMove2: move2,
    tplPagesArchiveSolutions: archiveSolutions,
    tplPagesInternationalMove: internationalMove,
    tplPagesLogisticsSolutions: logisticsSolutions,
    tplPagesBusinessStorage: businessStorage,
    tplPagesMoveNational: moveNational,
    tplPagesMoveInternational: moveInternational,
    tplPagesMoveNationalBusiness: moveNationalBusiness,
    tplPagesMoveInternationalBusiness: moveInternationalBusiness,
    tplPagesService: service,
    tplPagesFaq: faq,
    tplPagesJobs: jobs,
    tplPagesPricing: pricing,
    tplProfileManage: manage,
    tplUserPickup: pickup,
    tplUserBilling: billing,
    // @TODO - Clean those routes
    tplOrderCalculator: order,
    tplOrderStorage: order,
    tplOrderServices: order,
    tplOrderAppointment: order,
    tplOrderBilling: order,
    tplOrderReview: order,
    // @TODO - Clean those routes
    tplProfileAccount: account,
    tplProfileSponsorship: sponsorship,
}, config);

$(document).ready(() => routes.loadEvents());
